import PortalLogo from '../../assets/img/portal_logo_carousel.svg';

type Props = {
  className?: string;
};

const HeaderLogo = ({ className }: Props) => (
  <img
    src={PortalLogo}
    alt="logo"
    id="10nLogo"
    aria-label="10n logo"
    className={className}
  />
);

export default HeaderLogo;
